// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";
import { placeholders } from "../../utils/placeholders";

import {
  PURPOSE_KIND,
  AMOUNT,
  DEVELOPMENT_EXPENDITURE_DESCRIPTION,
  FEDERAL_STATE
} from "./formFields";
import { mapPurposeKind, getKind } from "./mappers";

import { type InvestmentSectionProps } from "../../types/details";

const InvestmentDevelopmentExpenditure = ({
  kind,
  initialValues,
  handleSubmit
}: InvestmentSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Investitionskosten",
            validate: v.combineWithPrefillCheck(
              errors.requiredField(),
              v.upperBound(999999999, errors.maxLengthDigits(9))
            )
          }}
          inputProps={{ placeholder: placeholders.inEuro, sideSymbol: () => "€" }}
          displayValue={formatters.formatCurrency}
          type="numberInput"
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: DEVELOPMENT_EXPENDITURE_DESCRIPTION,
            caption: () => "Beschreibung"
          }}
        />
        <div />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentDevelopmentExpenditure;
